import {
  AnchorButton as BlueprintAnchorButton,
  AnchorButtonProps as BlueprintAnchorButtonProps,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import {
  Body,
  Icon,
  IconComponentType,
} from 'vet-bones/design-system/components';

export type CreateProjectStepProps = Pick<
  BlueprintAnchorButtonProps,
  'active' | 'children' | 'disabled' | 'onClick'
> & {
  'data-testid'?: never;
  icon?: IconComponentType;
  iconSize?: 'lg' | 'md';
  leftBorder?: boolean;
  rightBorder?: boolean;
  stepIdx?: string;
  testId?: string;
  text?: string;
};

export const CreateProjectStep: React.VFC<CreateProjectStepProps> = ({
  active,
  children,
  disabled,
  icon,
  iconSize = 'md',
  leftBorder,
  onClick,
  rightBorder,
  stepIdx,
  testId,
  text,
}) => {
  const className = classNames('sd-create-project-step', {
    'sd-create-project-step--active': active,
    'sd-create-project-step--left-border': leftBorder,
    'sd-create-project-step--right-border': rightBorder,
  });
  const body = (
    <>
      {icon ? (
        <div
          className={classNames(
            'sd-create-project-step-icon',
            `sd-create-project-step-icon-size--${iconSize}`
          )}
        >
          <Icon IconComponent={icon} size={iconSize} />
        </div>
      ) : null}
      {text ? (
        <Body className="sd-create-project-step-text" ellipsize size="xl">
          {text}
        </Body>
      ) : null}

      {children}
      {stepIdx ? (
        <Body
          className="sd-create-project-step-idx"
          ellipsize
          size="xl"
          weight="light"
        >
          {stepIdx}
        </Body>
      ) : null}
    </>
  );

  return onClick ? (
    <BlueprintAnchorButton
      className={className}
      data-testid={testId}
      disabled={disabled}
      onClick={onClick}
    >
      {body}
    </BlueprintAnchorButton>
  ) : (
    <div className={className} data-testid={testId}>
      {body}
    </div>
  );
};
